/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/button-has-type */
import React,{ useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon, { IconType, IconSize } from '../icon/icon';
import { ButtonSize } from '../button/button';
import Modal,{ ModalSize } from '../../molecules/modal/modal';
import Button, { ButtonTheme, ButtonType } from '../../atoms/button/button';
import { httpPost, httpPostGetFile } from '../../../store/externalCalls/httpCalls';
import Toaste from '../toast/toaste';
import FormGroup from '../../organisms/formGroup/formGroup2';
import { useParams } from 'react-router-dom';

export const ButtonkSize = {
  BLOCK: 'block',
  LARGE: 'lg',
  SMALL: 'sm',
  '': '',
};

/**
 * Basic link component, it’s designed to edit the href attribute
 */
const ButtonForm = (props) => {
  const {
    onUpdateForm,theme, size, children, className, icon,text, iconColor, iconSize, disabled, actionUrl,value,formConfig,id,title,description,confirm,mode,actionParams,actionIsDownload
  } = props;
  const classProps = classNames(
    'btn',
    `btn-${theme}`,
    `btn-${size}`,
    className,
  );
  const [showModal,setShowModal] =useState(false);
  const [popupErrors,setPopupErrors] =useState({});
  const [fieldValue,setFieldValue] =useState({});
  const urlParams = useParams();
  const handlePopupOK=()=>{
        
    let params={};
    let finalUrl = actionUrl;
    if(actionParams)
    {      
      actionParams.forEach(
        param => finalUrl+= urlParams[param] ? `/${urlParams[param]}` : ''
      )
    }
    if(formConfig){
      params=fieldValue;
  }
    else
      params=value;
      
    if(actionIsDownload){
      httpPostGetFile(finalUrl, params, `liveLogs.csv`).then((res)=>{
        setShowModal(false);
        onUpdateForm(res);
    }).catch(error=>{
      setPopupErrors(error.errors);
      setTimeout(() => {
        setPopupErrors({});
      }, 2000);

    });}
    else
      httpPost(finalUrl, params).then((res)=>{
        setShowModal(false);
        onUpdateForm(res);
    }).catch(error=>{
      setPopupErrors(error.errors);
      setTimeout(() => {
        setPopupErrors({});
      }, 2000);
    });
  }
  const handlerOnClick=()=>{
    setFieldValue({});
    if(confirm)
       setShowModal(true);
    else
       handlePopupOK();
  }
  const handleOnClosePopup=()=>{
    setShowModal(false);
  }
  const handlerOnChange=(newValue)=>{
    setFieldValue({...fieldValue,...newValue});
    // setFieldValue({...fieldValue,...{[attributeName]:e.target.value}});
  }
  return (
    <div>
        {showModal && <Modal
          title={title}
          onClose={handleOnClosePopup}
          size={ModalSize.LARGE}
        >
          <div>
           
           {Object.keys(popupErrors).length > 0
          && (
            <Toaste type="error" mode="normal" data={popupErrors} />
          )}
        
         <div>{description}<br/><br/>
        
         </div>
        {formConfig &&
          <div>
            <FormGroup
              key={"popup-"+id}
              configFile={formConfig}
              value={fieldValue}
              onChange={handlerOnChange}
            />
          </div>}
         </div>
         <div style={{width:'100%'}}>
          <div style={{float:'left'}}>
          <Button
            id={`button-cancel`}
            type={ButtonType.BUTTON}
            onClick={() => handleOnClosePopup()}
            theme={ButtonTheme.SECONDARY}
            >
            Cancel
          </Button>
          </div>
          <div style={{float:'right'}}>
            <Button 
              id={`button-ok`}
              theme={ButtonTheme.PRIMARY}
              onClick={handlePopupOK}
            >
              Ok
            </Button>
          </div>
          </div>
        </Modal>}
        {mode=="link" && 
        <a
          id={'link-'+id}
          disabled={disabled}
          className={theme !== '' ? classProps : ''}
          onClick={handlerOnClick}
        >
          { icon !== ''
            && (
            <Icon
              icon={icon}
              iconSize={iconSize}
              iconColor={iconColor}
            />
            )}
            { text !== ''
            && (
            <span>{text}</span>
            )}
          {children}
        </a>}
        {mode=="button" && 
          <Button 
          id={`button-`+id}
          theme={ButtonTheme.PRIMARY}
          onClick={handlerOnClick}
        >
          {text}
        </Button>}
    </div>
  );
};

ButtonForm.propTypes = {
  /**
   * Link background color
   */
  theme: PropTypes.oneOf(Object.values(ButtonTheme)),
  /**
   * Link general size
   */
  size: PropTypes.oneOf(Object.values(ButtonSize)),
  /**
   * Content to put inside the link component
   */
  children: PropTypes.node,
  /**
   * CSS classes to customize link
   */
  className: PropTypes.string,
  /**
   * To select a icon inside the link
   */
  icon: PropTypes.oneOf(Object.values(IconType)),
  /**
   * Icon color inside the link
   */
  iconColor: PropTypes.string,
  /**
   * Icon size inside the link
   */
  iconSize: PropTypes.oneOf(Object.values(IconSize)),
  /**
   * To disable the link functionality
   */
  disabled: PropTypes.bool,
  /**
   * Link reference
   */
  to: PropTypes.string,
  confirm: PropTypes.bool,
  onUpdateForm: PropTypes.func,
  mode:PropTypes.string


};

ButtonForm.defaultProps = {
  theme: '',
  size: ButtonSize.SMALL,
  children: null,
  className: '',
  icon: '',
  iconColor: '',
  iconSize: IconSize.SMALL,
  disabled: false,
  confirm:false,
  mode:'link',
  onUpdateForm: () => { },

};

export default ButtonForm;
